import { type TextareaHTMLAttributes, forwardRef } from 'react'

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ className = '', ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        {...props}
        className={`w-full bg-ink-raised border border-haze px-5 py-3.5 text-cream placeholder-mute/60 outline-none transition-all duration-300 focus:border-ember resize-y leading-relaxed rounded-xl ${className}`}
        style={{ caretColor: 'var(--color-ember)', boxShadow: '0 0 0 3px rgba(196, 112, 90, 0.12)', ...props.style }}
      />
    )
  }
)

TextArea.displayName = 'TextArea'
